import { createRoutine } from 'redux-saga-routines';

export const fetchTags = createRoutine('assessment/FETCH_TAGS');
